import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import logo from '../../logo2.png';
import { Ghost, Loader } from 'lucide-react';

const AuthDispatcher = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const checkSession = async () => {
            try {
                const { data: { session } } = await supabase.auth.getSession();
                
                if (session) {
                    const manualExit = localStorage.getItem('cuconnect_manual_exit');
                    if (manualExit === 'true') {
                        navigate('/welcome', { replace: true });
                    } else {
                        navigate('/campus', { replace: true });
                    }
                } else {
                    navigate('/login', { replace: true });
                }
            } catch (error) {
                console.error("Auth check failed:", error);
                navigate('/login', { replace: true });
            }
        };

        checkSession();
    }, [navigate]);

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center">
            <img src={logo} alt="CUConnect" className="w-16 h-16 object-contain mb-8 opacity-20" />
            <div className="flex items-center gap-3 text-slate-400 font-medium text-sm tracking-wide">
                <Loader size={18} className="animate-spin text-indigo-600" />
                <span>Entering CUConnect</span>
            </div>
        </div>
    );
};

export default AuthDispatcher;
